var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto mx-auto"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Please wait"}}),_c('span',{staticClass:"ms-2 text-danger"},[_vm._v(_vm._s(_vm.msgText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }